<template>
  <div>
    <SfTable class="orders" v-if="orderGetters&&orderGetters.getOrder(list).length">
      <SfTableHeading>
        <SfTableHeader class="OrderIdTH">{{ $t('Order_No') }}</SfTableHeader>
        <SfTableHeader>{{ $t('Amount') }}</SfTableHeader>
        <SfTableHeader v-if="type == 'order'">{{ $t('payment_post_fee') }}</SfTableHeader>
        <SfTableHeader>{{ $t('Order_Status') }}</SfTableHeader>
        <SfTableHeader>{{ $t('Order_Detail') }}</SfTableHeader>
        <!--
          <SfTableHeader v-if="type != 'order' && type != 'ToBePaid'">
          {{ $t('Order_After_sales') }}
        </SfTableHeader>
          -->
      </SfTableHeading>

      <div class="orderTabody">
        <SfTableRow class="orderRow" v-for="item in orderGetters.getOrder(list)"
          :key="type == 'ToBePaid' ? item.prepay_id : orderGetters.getId(item)">
          <SfTableData v-e2e="'order-number'" class="OrderId">
            <div v-if="type != 'ToBePaid'">
              <div class="orderId">
                {{ orderGetters.getId(item) }}<br />
                {{ getCuurentDate(orderGetters.getDate(item)) }}
              </div>
            </div>
            <div v-else>
              <div class="orderId">
                <div v-for="order_id in item.order_ids" :key="order_id">{{ order_id }}</div>
                {{
                  item.order_list && item.order_list.length
                    ? getCuurentDate(item.order_list[0].create_time)
                    : ''
                }}
              </div>
            </div>
          </SfTableData>
          <SfTableData>
            <div v-if="type != 'ToBePaid'" class="orderPrice">
              {{
                $n(item.transAmount, {
                  style: 'currency',
                  currency: item.transCurrency,
                })
              }}
            </div>
            <div v-else class="orderPrice">
              {{
                item.order_list &&
                item.order_list.length &&
                $n(
                  item.amount,
                  item.order_list[0].trans_currency
                    ? {
                      style: 'currency',
                      currency: item.order_list[0].trans_currency || 'currency',
                    }
                    : 'currency'
              )
              }}
            </div>
          </SfTableData>
          <SfTableData v-if="type == 'order'">
            {{ $n(item.postFee,
              item.transCurrency
                ? {
                  style: 'currency',
                  currency: item.transCurrency || 'currency',
                }
                : 'currency') }}
          </SfTableData>
          <SfTableData>
            <span :class="getStatusTextClass(item)" style="font-size: 12px">{{
              $t(orderGetters.getStatus(item))
              }}</span>
          </SfTableData>
          <SfTableData :key="orderGetters.getId(item)">
            <SfButton class="sf-button--text" @click="backItem(item)">
              {{ $t('Order_View_details') }}
            </SfButton>
            <SfButton v-if="type == 'ToBePaid'" class="sf-button--text" @click="goPay(item)">
              {{ $t('go_pay_order') }}
            </SfButton>
            <SfButton v-if="type == 'ToBePaid'" class="sf-button--text" @click="cancelOrder(item)">
              {{ $t('closeOrder') }}
            </SfButton>
          </SfTableData>
          <!--
            <SfTableData :key="orderGetters.getId(item) + '' + orderGetters.getStatus(item)"
            v-if="type != 'order' && type != 'ToBePaid'">
            <div>
              <OrderAfterSalesStatus :orderId="orderGetters.getId(item)" :status="orderGetters.getStatus(item)"></OrderAfterSalesStatus> 
              <AfterSales :order="item" :isButton="true" :status="orderGetters.getStatus(item)"></AfterSales>
            </div>
          </SfTableData>-->
        </SfTableRow>
      </div>
    </SfTable>
  </div>
</template>
<script>
import {
  SfTable,
  SfButton,
  SfProperty,
  SfLink
} from '@storefront-ui/vue';
import { orderGetters, useCredential } from '@bee-hole/coms';
import { AgnosticOrderStatus } from '@vue-storefront/core';
import AfterSales from '~/components/Order/AfterSales';
import { useRouter } from '@nuxtjs/composition-api';
import { ref } from '@nuxtjs/composition-api';
import OrderAfterSalesStatus from '~/components/Order/OrderAfterSalesStatus';
export default {
  name: 'orderList',
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: String,
      default: 'order'
    }
  },
  components: {
    SfTable,
    SfButton,
    SfProperty,
    AfterSales,
    SfLink,
    OrderAfterSalesStatus
  },
  setup(prop, { emit, root }) {
    const { getPinJu, result: pingju } = useCredential();
    const router = useRouter();
    const closeOrderData = ref();
    const backItem = (item) => {
      emit('back', item);
    };
    const confirmModal1 = ref();
    const getCuurentDate = root?.$options?.getCuurentDate;
    const getStatusTextClass = (order) => {
      const status = orderGetters.getStatus(order);
      switch (status) {
        case AgnosticOrderStatus.Open:
          return 'text-warning';
        case AgnosticOrderStatus.Complete:
          return 'text-success';
        default:
          return '';
      }
    };
    const goPay = async (order) => {
      await getPinJu({ prepay_id: order.prepay_id });
      if (pingju.value?.credential_id) {
        const transformedPath = `/xpay?orderNumber=${order.prepay_id}&credential_id=${pingju.value?.credential_id}`;
        router.push(root.localePath(transformedPath));
      }
    };
    const okCloseOrder = () => {
      emit('cancelOrder', closeOrderData.value);
    };
    const cancelOrder = (order) => {
      closeOrderData.value = order;
      emit('cancelOrder', closeOrderData.value);
    };
    return {
      backItem,
      orderGetters,
      getStatusTextClass,
      goPay,
      getCuurentDate,
      cancelOrder,
      confirmModal1,
      okCloseOrder
    };
  }
};
</script>
<style lang="scss" scoped>
 .orderId{
    @include for-mobile{
        width:190px;
    }
  }
  .orderPrice{
    @include for-mobile{
        padding-left:1rem;
    }
  }

</style>
<style lang="scss">
.orderRow {
  .OrderId{
    @include for-mobile{
      width: 190px;
    }
    @include for-desktop{
      flex: 2;
    }
  }
}
.OrderIdTH{
  @include for-mobile{
    flex: 2 0 50%;
  }
  @include for-desktop{
    flex: 2;
  }
}
.orderTabody{
  display: flex;
  flex-direction: column;
      // height: 30vh;
      // overflow-y: auto;
}
</style>
